import { throttlePromise } from 'src/utils/throttle-promise.js'
import { getLastUnreadChangeLog, markLastUnreadChangeLogAsRead } from 'src/modules/changelogs/api.js'
import { empty } from 'src/utils/variable.js'
import { Dialog, Notify } from 'quasar'
import logger from 'src/services/logger/index.js'
import ChangelogsDialog from 'src/modules/changelogs/components/ChangelogsDialog.vue'

export const onShowLastUnreadChangelogDialog = throttlePromise(async () => {
  try {
    const changelog = (await getLastUnreadChangeLog()).data
    if (empty(changelog)) {
      return
    }

    Notify.create({
      message: 'Une nouvelle mise à jour est disponible !',
      caption: 'Cliquez pour découvrir les nouveautés',
      position: 'top',
      color: 'secondary',
      textColor: 'white',
      timeout: 0,

      icon: 'fa-solid fa-refresh',
      iconColor: 'white',
      iconSize: '20px',

      actions: [
        {
          icon: 'fa-solid fa-xmark',
          round: true,
          color: 'grey-4',
          handler: () => {
            try {
              markLastUnreadChangeLogAsRead()
            } catch (error) {
              logger.error(error)
            }
          },
          class: 'close-btn absolute-top-right'
        },
        {
          handler: () =>  {
            try {
              markLastUnreadChangeLogAsRead()
            } catch (error) {
              logger.error(error)
            }

            Dialog.create({
              component: ChangelogsDialog,
              componentProps: {
                changelog: changelog
              }
            })
          },
          class: 'click-area absolute-full'
        }
      ],
      classes: 'custom-notification'
    })
  } catch (error) {
    logger.error('Erreur lors de la récupération du changelog:', error)
  }
}, 24 * 60 * 60 * 1000)
